(() => {
  function openModal() {
    document.documentElement.classList.add('wh4-wishlist-open');
    const m = document.getElementById('wh4-wishlist-modal');
    if (m) { m.hidden = false; m.setAttribute('aria-hidden','false'); }
  }
  function closeModal() {
    document.documentElement.classList.remove('wh4-wishlist-open');
    const m = document.getElementById('wh4-wishlist-modal');
    if (m) { m.hidden = true; m.setAttribute('aria-hidden','true'); }
  }

  document.addEventListener('click', (e) => {
    const openBtn  = e.target.closest('[data-wh4-wishlist-open]');
    const closeBtn = e.target.closest('[data-wh4-wishlist-close]');
    if (openBtn)  { e.preventDefault(); openModal();  }
    if (closeBtn) { e.preventDefault(); closeModal(); }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeModal();
  });
})();
